import pepperResolveDialog from './pepperResolveAuth.component';

export default angular
  .module('st.Integrations.PepperResolve', ['st.Core', 'angular-cache'])
  .component('pepperResolveDialog', pepperResolveDialog)
  .service('pepperResolveService', ($http, dataService, PEPPER_RESOLVE) => ({
    send: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, PEPPER_RESOLVE.API.SEND, {
        params
      })
  }))
  .constant('PEPPER_RESOLVE', {
    API: {
      SEND: '/api/v1/integrations/pepperResolve/send/'
    }
  });
